export default __webpack_public_path__ + "static/media/gcp.c8afe9aa.svg";